const _ = require('./enum');

module.exports = {
  [_.CREDIT]: { id: _.CREDIT, label: 'Credit' },
  [_.DEBIT]: { id: _.DEBIT, label: 'Debit' },
  [_.PREPAID]: { id: _.PREPAID, label: 'Prepaid' },
};
